import sdkInstanceProvider from "../../providers/sdkInstanceProvider";
import savedItemsSdkProvider from "../../providers/savedItemsSdkProvider";
import clientConfigurationProvider from "../../providers/clientConfigurationProvider";
import { ServiceError, SdkError } from "../errors";
import isServiceError from "./isServiceError";
import isAxiosTimeout from "./isAxiosTimeout";
import { GET_SHARED_ITEMS_REQUEST_TIMEOUT } from "../../state/modules/savedItems/constants";
import inFlightCancellationFacade from "./inFlightCancellationFacade";

const { cancelTokenExecutor, makeRequest } = inFlightCancellationFacade();

const getSharedItems =
  ({ offset, limit, shareId, sort, sortOrder, cancelInFlight }) =>
  async () => {
    const {
      expands: { EXPAND_VARIANTS: expand },
      isRequestCancelled
    } = savedItemsSdkProvider();
    const sdkInstance = await sdkInstanceProvider("savedItems");
    const { getSharedItemsRequestTimeout } = clientConfigurationProvider();

    try {
      const { data } = await makeRequest({
        cancelInFlight,
        request: () =>
          sdkInstance.getSharedItems({
            offset,
            expand,
            limit,
            shareId,
            sort,
            sortOrder,
            requestOptions: {
              timeout: getSharedItemsRequestTimeout,
              cancelTokenExecutor
            }
          })
      });

      return data;
    } catch (e) {
      if (isRequestCancelled(e)) {
        return null;
      }
      if (isServiceError(e)) {
        throw new ServiceError(e);
      }
      if (isAxiosTimeout(e)) {
        throw new ServiceError(new Error(GET_SHARED_ITEMS_REQUEST_TIMEOUT));
      }
      throw new SdkError(e);
    }
  };

export default getSharedItems;
